import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    marginBottom: theme.spacing(3.75),
  },
  activeWalletContainer: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexDirection: 'column',
  },
  title: {
    fontWeight: 700,
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.cashbackWallet.textColor,
  },
  checkbox: {
    margin: 0,
    '& .MuiCheckbox-root': {
      padding: 0,
      marginRight: theme.spacing(0.5),
    },
    '& .MuiTypography-root': {
      lineHeight: 1,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.cashbackWallet.textColor,
    },
  },
  displayNone: {
    display: 'none !important',
  },
  utilizeWalletContainer: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexDirection: 'column',
  },
  balanceContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  balanceLabel: {
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cashbackWallet.textColor,
  },
  balance: {
    lineHeight: 1.08,
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.cashbackWallet.balanceColor,
  },
  balanceSymbol: {
    float: 'inline-start',
    marginRight: theme.spacing(2),
    fontSize: theme.typography.pxToRem(14),
  },
  redemptionLimitContainer: {
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.cashbackWallet.redemptionLimitBackgroundColor,
  },
  redemptionLimitLabel: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cashbackWallet.redemptionLimitColor,
  },
  redemptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  redemptionLabel: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cashbackWallet.labelColor,
  },
  interactiveContainer: {
    display: 'flex',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      flexDirection: 'column',
    },
  },
  currencyField: {
    flex: 1,
  },
  button: {
    flex: 1,
    position: 'relative',
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.cashbackWallet.buttonColor,
    color: theme.palette.cashbackWallet.buttonTextColor,
    '&::hover': {
      backgroundColor: theme.palette.cashbackWallet.buttonHoverColor,
    },

    '& .material-icons': {
      position: 'absolute',
      top: '50%',
      left: theme.spacing(2),
      transform: 'translateY(-50%)',
      color: theme.palette.cashbackWallet.buttonTextColor,
    },
  },
}))
